import { computed } from "mobx";
import { ExtendedModel, modelAction, tProp, types } from "mobx-keystone";
import { TModel } from "../../lib/models/t-model";
import { MeterStatus } from "../enums";
import { meterNS } from "./ns.meter";
import type { Self } from "../../lib/models/ref";
import type { MeterReadingModel } from "./model.meter-reading";

@meterNS.model
export class MeterModel extends ExtendedModel(TModel, {
  meterNum: tProp(types.string),
  serviceAddress: tProp(types.maybeNull(types.string)),
  location: tProp(types.maybeNull(types.string)),
  status: tProp(types.maybeNull(types.enum(MeterStatus))),
  serviceAccountId: tProp(types.string),
  lastMeasuredAt: tProp(types.maybeNull(types.string)),
  nextMeasureAt: tProp(types.maybeNull(types.string)),
}) {
  @computed
  get serviceAccount() {
    if (!this.detaching && this.root) {
      const account = this.root.tilliX.serviceAccounts.modelRef(
        this.serviceAccountId,
      );

      return account.maybeCurrent;
    }

    // biome-ignore lint/nursery/noUselessUndefined: <return undefined for getter>
    return undefined;
  }

  @computed
  get readings(): MeterReadingModel[] {
    if (this.detaching || !this.root) {
      return [];
    }
    return this.root.tilliX.meterReadings.data.filter(
      (reading) => reading.meter === this,
    );
  }

  @modelAction
  protected _setValueForKey<K extends keyof this & keyof Self<this>>(
    key: K,
    value: Self<this>[K] | this[K],
  ): void {
    this[key] = value;
  }
}
